// Count recipients consistently across split tasks and multiple payment orders.
export const customerCountKey = (item = {}) => {
  const shop = String(item.shopUserId || item.storeId || '');
  let phone = String(item.recipientPhone || item.phone || '').replace(/\D/g, '');
  if (phone.startsWith('886')) phone = `0${phone.slice(3)}`;
  if (/^0\d{8,10}$/.test(phone)) return `${shop}:phone:${phone}`;
  const buyerId = String(item.fromId || '').trim();
  return buyerId ? `${shop}:buyer:${buyerId}` : null;
};

export const createCustomerCountKey = (items = []) => {
  const phonesByBuyer = new Map();
  const buyerKey = (item) => `${String(item.shopUserId || item.storeId || '')}:buyer:${String(item.fromId || '').trim()}`;
  items.forEach((item) => {
    const key = customerCountKey(item);
    if (!item.fromId || !key?.includes(':phone:')) return;
    const buyer = buyerKey(item);
    if (!phonesByBuyer.has(buyer)) phonesByBuyer.set(buyer, new Set());
    phonesByBuyer.get(buyer).add(key);
  });
  return (item) => {
    const key = customerCountKey(item);
    if (!key?.includes(':buyer:')) return key;
    const phones = phonesByBuyer.get(buyerKey(item));
    if (!phones) return key;
    // A missing phone can be linked only when this buyer has one known recipient.
    return phones.size === 1 ? [...phones][0] : null;
  };
};
